module.exports = __webpack_public_path__ + "static/media/default.cf2baab2.png";


//////////////////
// WEBPACK FOOTER
// ./src/carManage/index/default.png
// module id = 1214
// module chunks = 0